import { LineItem, LineItemGroup } from '../types/quotation'

export function formatEuro(value: number): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0
  }).format(value)
}

export function lineTotal(item: LineItem): number {
  return item.unitPrice * item.quantity
}

export function groupTotal(group: LineItemGroup): number {
  return group.items.reduce((sum, item) => sum + lineTotal(item), 0)
}

export interface QuotationTotals {
  total: number
  campaigns: number
  annual: number
  integration: number
}

export function totalsFor(groups: LineItemGroup[]): QuotationTotals {
  const items = groups.flatMap((group) => group.items)
  const sumOf = (ids: string[]) =>
    items
      .filter((item) => ids.includes(item.id))
      .reduce((sum, item) => sum + lineTotal(item), 0)

  const campaigns = sumOf([
    'snakification',
    'website-localization',
    'master-campaigns',
    'localization',
    'activation'
  ])
  const annual = sumOf(['control-tower'])
  const integration = sumOf(['central-hub'])

  return {
    campaigns,
    annual,
    integration,
    total: campaigns + annual + integration
  }
}


